export default __webpack_public_path__ + "3de2aef983ffd650cfa2037ce7ddb612.png";